module.exports = __webpack_public_path__ + "img/logo-rafa.40d1b011.webp";